// extracted by mini-css-extract-plugin
export default {"scoreContainer":"CheckBoxScoreComponent_scoreContainer__Vx2Ja","header":"CheckBoxScoreComponent_header__DBfTl","options":"CheckBoxScoreComponent_options__Yo3Kz"};